import {
    Box,
    Chip,
    FormControl, FormControlLabel,
    InputAdornment,
    MenuItem,
    Radio,
    RadioGroup,
    Typography,
    useMediaQuery,
  } from "@mui/material";
  import { CalendarPicker, DatePicker, PickersDay } from "@mui/x-date-pickers";
  import moment from "moment";
import React, { useMemo, useState } from "react";
  import { Create} from "react-admin";
  import { ShortTimeEnum } from "../../enums/ShortTimeEnum";
  import CommonDialogForUserAndHouse from "../Common/CommonDialogUserAndHouse";
  import ResourceSelectDialog from "../Common/ResourceSelectDialog";
  import HouseList from "../Houses/HouseList";
  import { setCustomSelectOpen } from "../../store/reducers/customSelect";
  import { useAppDispatch } from "../../store/hooks";
  import EventBus from "../../EventBus";
  import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
  import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
  import { useNavigate } from "react-router-dom";
  import CircularLoader from "../Common/CircularLoader";
  import ComboList from "../Combo/ComboList";
  import { MultiDayChefitService } from "../../services/MultiDayChefitService";
import OccasionList from "../Common/OccasionList";
import ReasonSubreasonModuleEnum from "../../enums/ReasonSubreasonModuleEnum";
import { ActionTypeEnum } from "../../enums/ActionTypeEnum";
import {
  BlueBorderContainer,
  BlueTOpBorderContainer,
  FilledButton,
  FormFieldGroup,
  FormGrid,
  FormLabel as StyledFormLabel,
  OutlinedButton,
  SectionTitleRow,
  StyledDateText,
  StyledSelect,
  WorkspaceContainer,
  WorkspaceHeader,
  WorkspaceIconBadge,
  WorkspacePanel,
  WorkspaceTitle,
} from "../../styles/commonStyles";
import { CalendarIcon, EditIcon, HouseIcon, UserIcon } from "../Svg";
import { colors } from "../../styles/colors";
import { useSlotSizeOptions } from "../../utils/SlotSizeOptions";

  const multiDayChefitService = new MultiDayChefitService();

  const MultiDayChefitCreate = () => {
    const [dateMode, setDateMode] = useState<'range' | 'custom'>('range');
    const [customDates, setCustomDates] = useState<string[]>([]);
    const [tempDates, setTempDates] = useState<string[]>([]);
    const [calendarOpen, setCalendarOpen] = useState(false);
    const [calendarViewDate, setCalendarViewDate] = useState<any>(new Date());
    const [time, setTime] = useState<string>("");
    const [time2, setTime2] = useState<string>('');
    const [slotSize, setSlotSize] = useState<number | null>(null);
    const slotSizeOptions = useSlotSizeOptions();
    const [startDate, setStartDate] = useState<any>(null);
    const [endDate, setEndDate] = useState<any>(null)
    const [open, setOpen] = useState(false);
    const [houseId, setHouseId] = useState<any>(null);
    const [customerPhoneNumber, setCustomerPhoneNumber] = useState<string>("");
    const [openHouseDialog, setOpenHouseDialog] = useState(false);
    const [comboOpenDialog, setComboOpenDialog] = useState(false);
    const [comboId, setComboId] = useState<any>(null);
    const [loadingOnSubmit, setLoadingOnSubmit] = useState(false);
    const [multipleVisits, setMultipleVisits] = useState(false);
    const [occasion, setOccasion] = useState<string>("");
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));

    const ComboListByHouse = useMemo(
      () =>
        (props: any) => (
          <ComboList
            {...props}
            filter={
              customerPhoneNumber
                ? { customerPhoneNumber }
                : undefined
            }
          />
        ),
      [customerPhoneNumber]
    );

    const handleSelectHouse = () => {
      setOpenHouseDialog(true);
      dispatch(setCustomSelectOpen({ open: true }));
    };

    const handleComboOpen = () => {
      setComboOpenDialog(true);
      dispatch(setCustomSelectOpen({ open: true }));
    };

    const handleOpen = (value:boolean) => {
      if(value) handleSelectHouse();
    };

    const handleCloseHouse = (record: any) => {
      setOpenHouseDialog(false);
      setHouseId(record?.id);
      setCustomerPhoneNumber(record?.mobile || "");
      setComboId(null);
    };

    const handleCloseCombo = (record: any) => {
      setComboOpenDialog(false);
      setComboId(record?.id || null);
    };

    const toggleTempDate = (date: any) => {
      const formatted = moment(date).format("YYYY-MM-DD");
      if (moment(date).isBefore(moment(), 'day')) return;
      setTempDates(prev =>
        prev.includes(formatted)
          ? prev.filter(d => d !== formatted)
          : [...prev, formatted].sort()
      );
    };

    const openCalendar = () => {
      setTempDates([...customDates]);
      setCalendarOpen(true);
    };

    const confirmDates = () => {
      setCustomDates(tempDates);
      setCalendarOpen(false);
    };

    const cancelDates = () => {
      setTempDates([]);
      setCustomDates([]);
      setCalendarOpen(false);
    };

    const getVisitDateTimeArray = () => {
      if (dateMode === 'custom') {
        if (!customDates.length) return;
        const result: { date: string; time: string }[] = [];
        for (const date of customDates) {
          if (!time) return;
          result.push({ date, time });
          if (multipleVisits) {
            if (!time2) return;
            result.push({ date, time: time2 });
          }
        }
        return result;
      }

      if (!startDate || !endDate) return;
      const start = moment(startDate, "YYYY-MM-DD");
      const end = moment(endDate, "YYYY-MM-DD");
      const generatedDates = [];
      while (start.isSameOrBefore(end)) {
        if(!time) return;
        generatedDates.push({ date: start.format("YYYY-MM-DD"), time: time });
        if(multipleVisits) {
          if(!time2) return;
          generatedDates.push({ date: start.format("YYYY-MM-DD"), time: time2 });
        }
        start.add(1, "day");
      }
      return generatedDates;
    };

    async function createMultipleOneMealService() {
      let datesWithTimes = getVisitDateTimeArray();
      const multiDayChefitDetails: Record<string, unknown> = {
        'dateTime': datesWithTimes,
        'occasion': occasion,
      };
      // Backend rejects totalPeople: null, so send only the sizing field in use
      if (slotSize != null) {
        multiDayChefitDetails.slotSize = slotSize;
      }
      let payload = {
        'comboOrderId': comboId,
        'multiDayChefitDetails': multiDayChefitDetails,
        'useWalletCash': true,
      };

      setLoadingOnSubmit(true);
      multiDayChefitService.createMultiDayChefit(houseId, payload).then((data) => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Success",
          type: CustomSnackbarTypes.SUCCESS,
        });
        if (data?.id) {
          setLoadingOnSubmit(false);
          navigate(`/MultiDayChefit/${data?.id}/show`, { replace: true });
        }
      })
      .catch((err) => {
        setLoadingOnSubmit(false);
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: err?.response?.data?.error,
          type: CustomSnackbarTypes.ERROR,
        });
        navigate(`#/MultiDayChefit/create`, { replace: true });
      });
    }

    const handleSubmit = async() => {
      if (dateMode === 'custom') {
        if (customDates.length === 0) {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Please select at least one date",
            type: CustomSnackbarTypes.ERROR,
          });
          return;
        }
        if ((!multipleVisits && !time) || (multipleVisits && (!time || !time2))) {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Please enter time slots",
            type: CustomSnackbarTypes.ERROR,
          });
          return;
        }
      } else {
        if(!startDate || !endDate){
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Please Enter Start date and End date",
            type: CustomSnackbarTypes.ERROR,
          });
          return;
        }
        if((!multipleVisits && !time) || (multipleVisits && !time && !time2)){
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Please Enter Time slots",
            type: CustomSnackbarTypes.ERROR,
          });
          return;
        }
      }
      if (slotSize == null) {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Please select slot size",
          type: CustomSnackbarTypes.ERROR,
        });
        return;
      }
      if(!comboId || !houseId){
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Please select pack and house",
          type: CustomSnackbarTypes.ERROR,
        });
        return;
      }
      createMultipleOneMealService();
    };

    return (
      <WorkspaceContainer>
        <WorkspaceHeader>
          <SectionTitleRow>
            <WorkspaceIconBadge>
              <EditIcon />
            </WorkspaceIconBadge>
            <div>
              <WorkspaceTitle>Create Multi Day Chefit</WorkspaceTitle>
            </div>
          </SectionTitleRow>
        </WorkspaceHeader>

        {loadingOnSubmit ? <CircularLoader /> : (
          <WorkspacePanel>
            <Create title={"Create Multi Day Chefit"} sx={{
              "& .RaCreate-card": { backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }
            }}>
              <>
                {/* House / Pack selection */}
                <BlueBorderContainer>
                  <div>
                    <Box display="flex" gap="1rem" flexWrap="wrap">
                      <FilledButton onClick={() => handleOpen(true)}>
                        <HouseIcon />
                        {houseId ? `House ID: ${houseId}` : "Choose House"}
                      </FilledButton>
                      {houseId && (
                        <FilledButton onClick={() => handleComboOpen()}>
                          <HouseIcon />
                          {comboId ? `Pack ID: ${comboId}` : "Choose Pack"}
                        </FilledButton>
                      )}
                    </Box>
                  </div>
                  <div>
                    <CommonDialogForUserAndHouse open={open} setOpen={setOpen} setHouse={setHouseId} />
                    {openHouseDialog && (
                      <ResourceSelectDialog name={"Houses"} list={HouseList} onClose={handleCloseHouse} />
                    )}
                    {comboOpenDialog && (
                      <ResourceSelectDialog name={"Combo"} list={ComboListByHouse} onClose={handleCloseCombo} />
                    )}
                    <OutlinedButton onClick={() => setOpen(true)} style={{ marginLeft: isSmall ? "0" : undefined }}>
                      <UserIcon color={colors.primary} width={28} height={28} />
                      Create Customer and House
                    </OutlinedButton>
                  </div>
                </BlueBorderContainer>

                {/* Date mode radio */}
                <FormGrid>
                  <FormFieldGroup>
                    <StyledFormLabel>Date Selection</StyledFormLabel>
                    <FormControl>
                      <RadioGroup
                        row
                        value={dateMode}
                        onChange={(e) => {
                          setDateMode(e.target.value as 'range' | 'custom');
                          setStartDate(null);
                          setEndDate(null);
                          setCustomDates([]);
                          setTempDates([]);
                          setCalendarOpen(false);
                        }}
                      >
                        <FormControlLabel value="range" control={<Radio />} label="Date Range" />
                        <FormControlLabel value="custom" control={<Radio />} label="Custom Dates" />
                      </RadioGroup>
                    </FormControl>
                  </FormFieldGroup>
                </FormGrid>

                {/* Date Range — Start Date | End Date | Total People in one row */}
                {dateMode === 'range' && (
                  <FormGrid style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                    <FormFieldGroup>
                      <StyledFormLabel>Start Date</StyledFormLabel>
                      <FormControl style={{ width: "100%" }}>
                        <DatePicker
                          inputFormat="dd MMM yyyy"
                          disableMaskedInput
                          minDate={new Date()}
                          value={startDate}
                          onChange={(value: any) => setStartDate(moment(value).format("YYYY-MM-DD"))}
                          renderInput={(params: any) => <StyledDateText {...params} label="" variant="outlined" />}
                        />
                      </FormControl>
                    </FormFieldGroup>
                    <FormFieldGroup>
                      <StyledFormLabel>End Date</StyledFormLabel>
                      <FormControl style={{ width: "100%" }}>
                        <DatePicker
                          inputFormat="dd MMM yyyy"
                          disableMaskedInput
                          minDate={new Date()}
                          value={endDate}
                          onChange={(value: any) => setEndDate(moment(value).format("YYYY-MM-DD"))}
                          renderInput={(params: any) => <StyledDateText {...params} label="" variant="outlined" />}
                        />
                      </FormControl>
                    </FormFieldGroup>
                    <FormFieldGroup>
                      <StyledFormLabel>Slot Size (Hours)</StyledFormLabel>
                      <FormControl style={{ width: "100%" }}>
                        <StyledSelect
                          labelId="forSlotSize"
                          id="slotSize"
                          variant="outlined"
                          value={slotSize ?? ""}
                          label="Slot Size"
                          onChange={(event: any) => setSlotSize(event.target.value)}
                        >
                          {slotSizeOptions.map((e) => (
                            <MenuItem key={e} value={e}>{e} hr{e !== 1 ? "s" : ""}</MenuItem>
                          ))}
                        </StyledSelect>
                      </FormControl>
                    </FormFieldGroup>
                  </FormGrid>
                )}

                {/* Custom Dates — trigger field | Total People in one row */}
                {dateMode === 'custom' && (
                  <FormGrid style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                    <FormFieldGroup>
                      <StyledFormLabel>Select Dates</StyledFormLabel>
                      {/* Trigger field — same look as DatePicker renderInput */}
                      <FormControl style={{ width: '100%' }}>
                      <StyledDateText
                        variant="outlined"
                        label=""
                        value={customDates.length ? `${customDates.length} date(s) selected` : ''}
                        placeholder="dd mmm yyyy"
                        onClick={openCalendar}
                        inputProps={{ readOnly: true, style: { cursor: 'pointer' } }}
                        style={{ width: '100%', cursor: 'pointer' }}
                        sx={{
                          '& .MuiOutlinedInput-root': { cursor: 'pointer' },
                          '& .MuiOutlinedInput-input': { cursor: 'pointer' },
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end" style={{ cursor: 'pointer' }}>
                              <CalendarIcon color="#888" width={20} height={20} />
                            </InputAdornment>
                          ),
                        }}
                      />
                      </FormControl>

                      {/* Chips after confirm */}
                      {!calendarOpen && customDates.length > 0 && (
                        <Box sx={{ mt: 1.5 }}>
                          <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
                            Selected ({customDates.length}):
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                            {customDates.map(d => (
                              <Chip
                                key={d}
                                label={moment(d).format("DD MMM YYYY")}
                                size="small"
                                onDelete={() => setCustomDates(prev => prev.filter(x => x !== d))}
                                color="primary"
                                variant="outlined"
                              />
                            ))}
                          </Box>
                        </Box>
                      )}
                    </FormFieldGroup>

                    <FormFieldGroup>
                      <StyledFormLabel>Slot Size (Hours)</StyledFormLabel>
                      <FormControl style={{ width: "100%" }}>
                        <StyledSelect
                          labelId="forSlotSize"
                          id="slotSize"
                          variant="outlined"
                          value={slotSize ?? ""}
                          label="Slot Size"
                          onChange={(event: any) => setSlotSize(event.target.value)}
                        >
                          {slotSizeOptions.map((e) => (
                            <MenuItem key={e} value={e}>{e} hr{e !== 1 ? "s" : ""}</MenuItem>
                          ))}
                        </StyledSelect>
                      </FormControl>
                    </FormFieldGroup>
                  </FormGrid>
                )}

                {/* Calendar + Confirm/Cancel — shown below the row when open */}
                {dateMode === 'custom' && calendarOpen && (
                  <Box sx={{ mt: 1 }}>
                    <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 2, display: 'inline-block', overflow: 'hidden' }}>
                      <CalendarPicker
                        date={calendarViewDate}
                        onChange={(newDate: any) => {
                          setCalendarViewDate(newDate);
                          toggleTempDate(newDate);
                        }}
                        minDate={new Date()}
                        renderDay={(day: any, _val: any, pickersDayProps: any) => {
                          const formatted = moment(day).format("YYYY-MM-DD");
                          const isSelected = tempDates.includes(formatted);
                          return (
                            <PickersDay
                              {...pickersDayProps}
                              selected={false}
                              style={isSelected ? {
                                backgroundColor: '#1976d2',
                                color: '#ffffff',
                                borderRadius: '50%',
                              } : {}}
                            />
                          );
                        }}
                      />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                      <FilledButton onClick={confirmDates} style={{ padding: '4px 20px' }}>
                        Confirm
                      </FilledButton>
                      <OutlinedButton onClick={cancelDates} style={{ padding: '4px 20px' }}>
                        Cancel
                      </OutlinedButton>
                    </Box>
                  </Box>
                )}

                {/* No. of Visits */}
                <FormGrid>
                  <FormFieldGroup>
                    <StyledFormLabel>No. of Visits</StyledFormLabel>
                    <FormControl>
                      <RadioGroup
                        row
                        value={multipleVisits}
                        onChange={(e) => setMultipleVisits(e.target.value === "true")}
                      >
                        <FormControlLabel value={false} control={<Radio />} label="Single" />
                        <FormControlLabel value={true} control={<Radio />} label="Multiple" />
                      </RadioGroup>
                    </FormControl>
                  </FormFieldGroup>
                </FormGrid>

                {/* Time */}
                {!multipleVisits ? (
                  <FormGrid>
                    <FormFieldGroup>
                      <StyledFormLabel>One Meal Time</StyledFormLabel>
                      <FormControl style={{ width: "100%" }}>
                        <StyledSelect
                          labelId="forTime"
                          id="time"
                          variant="outlined"
                          value={time}
                          label="One Meal Time"
                          onChange={(event: any) => setTime(event.target.value)}
                        >
                          {Object.values(ShortTimeEnum).map((e) => (
                            <MenuItem key={e} value={e}>{e}</MenuItem>
                          ))}
                        </StyledSelect>
                      </FormControl>
                    </FormFieldGroup>
                  </FormGrid>
                ) : (
                  <FormGrid>
                    <FormFieldGroup>
                      <StyledFormLabel>One Meal Time 1</StyledFormLabel>
                      <FormControl style={{ width: "100%" }}>
                        <StyledSelect
                          labelId="forTime1"
                          id="time1"
                          variant="outlined"
                          value={time}
                          label="One Meal Time 1"
                          onChange={(event: any) => setTime(event.target.value)}
                        >
                          {Object.values(ShortTimeEnum).map((e) => (
                            <MenuItem key={e} value={e}>{e}</MenuItem>
                          ))}
                        </StyledSelect>
                      </FormControl>
                    </FormFieldGroup>
                    <FormFieldGroup>
                      <StyledFormLabel>One Meal Time 2</StyledFormLabel>
                      <FormControl style={{ width: "100%" }}>
                        <StyledSelect
                          labelId="forTime2"
                          id="time2"
                          variant="outlined"
                          value={time2}
                          label="One Meal Time 2"
                          onChange={(event: any) => setTime2(event.target.value)}
                        >
                          {Object.values(ShortTimeEnum).map((e) => (
                            <MenuItem key={e} value={e}>{e}</MenuItem>
                          ))}
                        </StyledSelect>
                      </FormControl>
                    </FormFieldGroup>
                  </FormGrid>
                )}

                {/* Occasion */}
                <FormGrid>
                  <FormFieldGroup>
                    <StyledFormLabel>Occasion Type</StyledFormLabel>
                    <OccasionList
                      occasion={occasion}
                      setOccasion={setOccasion}
                      module={ReasonSubreasonModuleEnum.MULTI_DAY_CHEFIT}
                      actionType={ActionTypeEnum.OCCASION}
                    />
                  </FormFieldGroup>
                </FormGrid>

                {/* Submit */}
                <BlueTOpBorderContainer>
                  <FilledButton
                    variant="contained"
                    onClick={handleSubmit}
                    style={{ padding: '6px 32px' }}
                  >
                    Submit
                  </FilledButton>
                </BlueTOpBorderContainer>
              </>
            </Create>
          </WorkspacePanel>
        )}
      </WorkspaceContainer>
    );
  };

  export default MultiDayChefitCreate;
